import { LoginForm } from './LoginForm';
import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../../core/helpers/msal';

export function AuthorizationPage() {
    const { instance } = useMsal();

    return (
        <LoginForm
            pending={false}
            loginError={!instance ? 'msalInstanceNotInitialized' : ''}
            onSubmitLogin={() => {
                instance.loginRedirect(loginRequest).catch(e => console.log(e));
            }}
        />
    );
}
